export type LocalSprite = {
  id: string;
  name?: string;
  title?: string;
  label?: string;
  pixels?: number[][];
  palette?: string[];
  updated: number;
};

const KEY = 'pp_local_sprites_v1';

type Store = Record<string, LocalSprite>;

function load(): Store {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; }
}
function save(s: Store) {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch {}
}

export function listLocalSprites(): LocalSprite[] {
  return Object.values(load()).sort((a,b)=> (b.updated||0)-(a.updated||0));
}

export function upsertLocalSprite(rec: Partial<LocalSprite>) {
  const s = load();
  const id = rec.id || (crypto?.randomUUID ? crypto.randomUUID() : String(Date.now()));
  s[id] = {
    id,
    name: rec.name || rec.title || rec.label || 'untitled',
    title: rec.title,
    label: rec.label,
    pixels: rec.pixels,
    palette: rec.palette,
    updated: Date.now(),
  };
  save(s);
  return s[id];
}

export function removeLocalSprite(id: string) {
  const s = load();
  delete s[id];
  save(s);
}